import Vuex, { GetterTree } from 'vuex';
import { AdmissionState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<AdmissionState, RootState> = {
  admissionId: (state, getters) => {
    return state.admissionId;
  },
  selectedAdmissionType: (state, getters) => {
    return state.admissionType;
  },
  availableAdmissionTypes: (state, getters) => {
    return state.availableAdmissionTypes;
  },
  availableEnemYears: (state, getters) => {
    return state.availableEnemYears;
  },
  enem: (state, getters) => {
    return state.enem;
  },
  enemGradesAverage: (state, getters) => {
    const grades = state.enem?.grades || {};
    const gradesValues = Object.values(grades);
    return gradesValues.reduce((total, grade) => total + grade / gradesValues.length, 0);
  },
  evaluationStatus: (state, getters) => {
    return state.evaluationStatus;
  },
  secondGraduation: (state, getters) => {
    return state.secondGraduation;
  },
  transferGraduation: (state, getters) => {
    return state.transferGraduation;
  },
  availableInstitutions: (state, getters) => {
    return state.availableInstitutions;
  },
};

export default getters;
